import adjustmentAPI from '@/services/API/adjustment'

const fetchReasons = function({ commit , state}, query) {
  if(state.reasonsOutdated){
    commit('SET_LOADING_REASONS', true);
    return adjustmentAPI.fetchAdjustmentReasons({active:'true'})
      .then(reasons=>{
        commit("UPDATE_ADJUSTMENT_REASONS", reasons);
        commit('SET_LOADING_REASONS', false);
      })
  }
};

const invalidateReasons = function({commit}){
  commit('INVALIDATE_REASONS');
}

const reset = function({ commit }) {
  commit('RESET_STATE');
};

const setAdjustmentProp = function({commit,dispatch}, adjustment){
  _.forEach(['description','mode','reference','effective_date','reason'],prop=>{
    if(adjustment.hasOwnProperty(prop)){
      commit('SET_ADJUSTMENT_PROPERTY', {propName : prop, propVal:adjustment[prop]});
    }
  })
}

const initAdjustment = function({commit}, {onProduct, product, productItems, inventoryId}){
  // console.log({onProduct, product, productItems, inventoryId})
  commit('SET_ON_PRODUCT', onProduct);
  commit('SET_INVENTORY_ID', inventoryId);
  if(onProduct){
    commit('SET_ADJUSTED_PRODUCT', product);
    commit('SET_ADJUSTED_PRODUCT_ITEMS', productItems)
  }
}

const setAdjustedProductQuantity = function({commit,dispatch}, {adjusted_qty, diff}){
  commit('SET_ADJUSTED_PRODUCT_QUANTITY',{adjusted_qty, diff});
}

const setAdjustedProductItem = function({commit,dispatch}, item){
  commit('SET_ADJUSTED_PRODUCT_ITEM',item);
}

const postAdjustment = function ({commit, dispatch, state}){
  if(state.onProduct){
    commit('ADD_ADJUSTED_ITEM_TO_ADJUSTMENT',state.adjustedProduct);
  }

  return adjustmentAPI.postAdjustment(state.adjustment)
}

export default {
  fetchReasons,
  reset,
  setAdjustmentProp,
  initAdjustment,
  setAdjustedProductQuantity,
  setAdjustedProductItem,
  postAdjustment
};
